import { Form } from "antd";
import { FC, ComponentType } from "react";
import HotelSelect from "../LocationSearch/HotelSelect";

type HotelSelectContentProps = {
  name: string;
  rules: any[];
  dependencies?: string[];
  label: string;
  icon: ComponentType<{ className?: string }>;
  className?: string;
  closeSheet?: () => void;
};

const HotelSelectContent: FC<HotelSelectContentProps> = ({ name, rules, dependencies, label, icon, className, closeSheet }) => {
  return (
    <Form.Item
      name={name}
      dependencies={dependencies}
      className="m-0! focus-within:ring-0! w-full min-w-0 font-semibold md:min-w-0 md:flex-1 md:border-none [&_.ant-form-item-explain-error]:hidden [&_.ant-form-item-explain-error]:md:block [&_.ant-form-item-explain-error]:md:px-4!"
      rules={rules}
    >
      <HotelSelect label={label} icon={icon} className={className} onFinishSelect={closeSheet} />
    </Form.Item>
  );
};

export default HotelSelectContent;
